import styled from "styled-components";

interface StyledUploadButtonProps {
  primary?: boolean;
}

const StyledUploadButton = styled.label<StyledUploadButtonProps>`
  position: relative;
  height: auto;
  box-sizing: border-box;
  padding: ${({ theme }) => theme.paddingButton};
  background-color: ${({ theme, primary }) =>
    primary ? theme.colors.primaryButton : "transparent"};
  color: ${({ theme, primary }) =>
    primary ? theme.colors.baseWhite : theme.colors.primary1};
  border: ${(props) => `1px solid ${props.theme.colors.primaryButton}`};
  border-radius: ${(props) => props.theme.borderRadiusButton};
  outline: none;
  font-family: ${(props) => props.theme.fonts.button.family};
  font-size: ${(props) => props.theme.fonts.button.fontSize};
  line-height: ${(props) => props.theme.fonts.button.lineHeight};
  font-weight: ${(props) => props.theme.fonts.button.fontWeight};
  letter-spacing: ${(props) => props.theme.fonts.button.letterSpacing};
  text-align: center;

  &:hover {
    background-color: ${({ theme }) => theme.colors.primary1opacity40};
    border: ${({ theme }) => `1px solid ${theme.colors.primary1opacity40}`};
    color: ${({ theme }) => theme.colors.primaryButtonHover};
    cursor: pointer;
  }

  &:focus-within::after {
    content: "";
    position: absolute;
    left: -4px;
    right: -4px;
    top: -4px;
    bottom: -4px;
    background-color: transparent;
    border: ${(props) => `2px solid ${props.theme.colors.highlight1}`};
    border-radius: ${(props) => props.theme.borderRadiusButton};
  }

  &:disabled {
    background-color: transparent;
    border: ${(props) => `1px solid ${props.theme.colors.disabled1}`};
  }
`;

export default StyledUploadButton;
